import React, { useEffect } from "react";
import dataLayer from '../../utils/dataLayer';

const StatusBoxSuccess = (props) => {
  useEffect(() => {
    dataLayerHandler();
  }, []);

  const dateDifference = () => {
    var date1 = new Date(props.purchase.departure_date);
    var date2 = new Date(props.purchase.return_date);
    var difference_In_Time = date2.getTime() - date1.getTime();
    var difference_In_Days = difference_In_Time / (1000 * 3600 * 24);
    return difference_In_Days;
  };

  const dataLayerHandler = () => {
    dataLayer.raw({
      event: 'confirmacao_pedido',
      dados_pedido: {
        id_pedido: props.purchase.id,
        plano: props.purchase.product,
        seguradora: props.purchase.provider,
        meio_de_pagamento: props.purchase.payment_method,
        destino: props.purchase.destination,
        data_embarque: props.purchase.departure_date,
        data_desembarque: props.purchase.return_date,
        tempo_permanencia: dateDifference(),
      },
    });
  };

  return (
    <div className="box success" style={{ zIndex: 4 }}>
      <div className="success-header">
        <img className="img-success" src="/assets/images/check-sucess.svg" alt="Selecionado" />
      </div>
      <div className="success-body">
        <h1>{props.purchase.payment_status === 'Aprovado' ? 'Pagamento confirmado com sucesso!' : 'Pedido recebido com sucesso!'}</h1>
        <div className="box-order-number">
          <div className="box-green">
            <div className="text-number-purchase">
              Número do seu pedido:&nbsp;
              <span className="number-purchase">{props.purchase.id}</span>
            </div>
          </div>
        </div>
        <div className="text-success-info">
          {props.purchase.payment_status === 'Aprovado' ? (
            <span>
              Olá, <strong>{props.purchase.contact_name.split(" ")[0]}</strong>! Recebemos o seu pagamento, que foi processado com sucesso e o pedido
              está em andamento para a emissão da sua apólice.
              <br />
              <br />
              Em breve, você receberá os detalhes da apólice no e-mail cadastrado no pedido. Qualquer dúvida adicional, entraremos em contato por e-mail.
              <br />
              <br />
              Vamos juntos construir e manter a segurança.{" "}
              <a href="https://www.segurospromo.com.br/atendimento/" rel="noopener noreferrer" target="__blank">
                Pode contar com a gente!
              </a>
            </span>
          ) : props.purchase.payment_method === "Boleto" ? (
            <span>
              Olá, <strong>{props.purchase.contact_name.split(" ")[0]}</strong>! Recebemos o seu pedido, assim que identificarmos o pagamento do
              boleto iremos prosseguir com a emissão da sua apólice. O boleto tem prazo de compensação de 1 a 2 dias úteis.
            </span>
          ) : (
            <span>
              Olá, {props.purchase.contact_name.split(" ")[0]}! Recebemos o seu pedido, neste momento ele está sendo processado e o pagamento está
              sendo analisado por nossa equipe.
            </span>
          )}
          {props.purchase.payment_status !== 'Aprovado' && (
            <React.Fragment>
              <br />
              <br />
              Em breve, você receberá os detalhes e atualização do seu pedido no seu e-mail. Caso tenha alguma dúvida, entre em contato com a nossa{" "}
              <br />
              <a href="https://www.segurospromo.com.br/atendimento/" rel="noopener noreferrer" target="__blank">
                central de atendimento
              </a>
              .
            </React.Fragment>
          )}
        </div>
      </div>
    </div>
  );
};

export default StatusBoxSuccess;



// WEBPACK FOOTER //
// ./src/components/purchase_status/StatusBoxSuccess.jsx